// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "/riskmap-js/" + ({"53":"webfontloader","594":"about"}[chunkId] || chunkId) + "." + {"53":"8ae68af5","97":"2423c4db","594":"8c7e3743"}[chunkId] + ".js";
};